import React from 'react';

import LoginForm from '../components/LoginForm';

const LoginPage = () => <LoginForm/>

export default LoginPage;